import { render } from "./aadhar_survey.vue?vue&type=template&id=ba601d7a&scoped=true"
import script from "./aadhar_survey.vue?vue&type=script&lang=js"
export * from "./aadhar_survey.vue?vue&type=script&lang=js"

import "./aadhar_survey.vue?vue&type=style&index=0&id=ba601d7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba601d7a"]])

export default __exports__